module.exports = __webpack_public_path__ + "static/img/scene-4.d9494f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scene-4.jpg
// module id = ujc1
// module chunks = 73